import { getGlobalEventsLogs } from '@cian/events-log';

import { TOPIC_USER } from '../../eventsLogs/topics';
import { IViewData, TAuthenticationModalType } from '../../types/authenticationModal';

export interface ICallAuthenticationPopupParameters {
  type?: TAuthenticationModalType;
  viewData?: IViewData;
  source?: string;
  autoRefresh?: boolean;
}

export function callAuthenticationPopup(parameters?: ICallAuthenticationPopupParameters) {
  const globalLog = getGlobalEventsLogs();

  globalLog.produce(TOPIC_USER, {
    type: 'authenticate',
    value: {
      autoRefresh: typeof parameters?.autoRefresh === 'boolean' ? parameters.autoRefresh : true,
      alert: parameters?.type || '',
      viewData: parameters?.viewData || {},
      source: parameters?.source || null,
    },
  });
}
